module.exports = __webpack_public_path__ + "static/media/sicherung_fertig.0f92ccbc.jpg";